import React, { Component } from "react";

class PricingCart extends Component {
  render() {
    return (
      <div>
        <div className="col-md-4 col-sm-12 col-xs-12" id="pages">
          <div className="x_panel paymentDesc">
            <div className="x_content">
              <div className="paymentDesc page block" id="information" data-page="information">
                <div className="x_content">
                  <div className="pricing_features">
                    <h3>No monthly payment and your credits never expire</h3>
                    <br />
                    <ul className="list-unstyled text-left">
                      <li>
                        <i className="fa fa-check text-primary" /> <strong>Volume Discount :</strong> The more you
                        verify, the lower the cost.
                        <br />
                      </li>
                      <li>
                        <i className="fa fa-check text-primary" /> <strong>Free Deduplication :</strong> We remove
                        duplicate and invalid format emails at no extra cost.
                        <br />
                      </li>
                      <li>
                        <i className="fa fa-check text-primary" /> <strong>No Hidden Fees :</strong> No charges for
                        unknown or duplicate emails.
                      </li>
                    </ul>
                  </div>
                  <div className="pricing_footer">
                    <p>Need some assistance?</p>
                    <a href="javascript:void(0);" className="btn btn-default bg-orange" role="button">
                      Help{" "}
                    </a>
                  </div>
                </div>
              </div>

              <div className="checkout page hide" id="portfolio" data-page="portfolio">
                <h3>
                  Cart
                  <small className="count-items">
                    ( <span className="nbItems">1</span> Items)
                  </small>
                  <a href="#" className="close-sign">
                    <i className="fa fa-times" aria-hidden="true" />
                  </a>
                </h3>
                <section id="checkout-cart">
                  <table width="100%" border="1">
                    <tbody>
                      <tr>
                        <th scope="col" width="25%">
                          Package
                        </th>
                        <th scope="col" width="30%">
                          Qte
                        </th>
                        <th scope="col" width="45%">
                          Price
                        </th>
                      </tr>
                      <tr>
                        <th scope="row">500</th>
                        <td>
                          <input readonly="" value="1" type="number" />
                        </td>
                        <td>
                          $4{" "}
                          <a href="javascript:void(0)" onclick="addToCart(7,'delete')">
                            x
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p>Verifications</p>
                          <strong>Total</strong>
                        </td>
                        <td>&nbsp;</td>
                        <td>
                          <p>500</p>
                          <strong>$4</strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <br />
                  <button type="button" className="btn btn-primary btn-block bg-green checkoutBtn" data-page="blog">
                    Checkout Now
                  </button>
                </section>
              </div>

              <div className="page hide" data-page="blog" id="blog">
                <form id="demo-form" data-parsley-validate="" novalidate="">
                  <h3>Account Info</h3>
                  <p>
                    <label for="fullname">Card Number * :</label>
                    <input id="fullname" className="form-control" name="fullname" required="" type="text" />
                  </p>
                  <p>
                    <label for="fullname">Expiration * :</label>
                    <input id="fullname" className="form-control" name="fullname" required="" type="text" />
                  </p>
                  <p>
                    <label for="fullname">CVC * :</label>
                    <input id="fullname" className="form-control" name="fullname" required="" type="text" />
                  </p>
                  <hr />
                  <p>
                    <label for="fullname">Coupon * :</label>
                    <input id="fullname" className="form-control" name="fullname" required="" type="text" />
                  </p>

                  <p>
                    <label for="fullname">Full Name * :</label>
                    <input
                      autocomplete="cc-number"
                      autocorrect="off"
                      name="cardnumber"
                      aria-label="Credit or debit card number"
                      placeholder="Card number"
                      aria-placeholder="Card number"
                      aria-invalid="false"
                      value=""
                      className="form-control"
                      type="tel"
                    />
                  </p>

                  <p>
                    <label for="email">Email * :</label>
                    <input
                      id="email"
                      className="form-control"
                      name="email"
                      data-parsley-trigger="change"
                      required=""
                      type="email"
                    />
                  </p>

                  <p>
                    <label for="email">Full Address :</label>
                    <textarea
                      id="message"
                      required="required"
                      className="form-control"
                      name="message"
                      data-parsley-trigger="keyup"
                      data-parsley-minlength="20"
                      data-parsley-maxlength="100"
                      data-parsley-minlength-message="Come on! You need to enter at least a 20 caracters long comment.."
                      data-parsley-validation-threshold="10"
                    />
                  </p>

                  <p>
                    <label for="email">City :</label>
                    <input
                      id="email"
                      className="form-control"
                      name="email"
                      data-parsley-trigger="change"
                      required=""
                      type="email"
                    />
                  </p>

                  <p>
                    <label for="email">Country :</label>
                    <input
                      id="email"
                      className="form-control"
                      name="email"
                      data-parsley-trigger="change"
                      required=""
                      type="email"
                    />
                  </p>

                  <div className="autoRecharge">
                    <input type="checkbox" /> <label>Auto-Recharge</label>
                  </div>

                  <label className="">
                    <div className="iradio_flat-green checked">
                      <input className="flat" checked="" name="iCheck" type="radio" />
                      <ins className="iCheck-helper" />
                    </div>{" "}
                    Checked
                  </label>

                  <br />
                  <a href="#" className="btn btn-primary btn-block bg-green">
                    Purchage Pacakge
                  </a>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PricingCart;



// WEBPACK FOOTER //
// ./src/components/Pricing/PricingContainer/PricingCart.js